import { createFileRoute, Outlet } from "@tanstack/react-router";
import type { JSX } from "react";
import { useEffect } from "react";
import { notifyTeamsAppLoaded } from "@/lib/teams/host";

const TeamsLayout = (): JSX.Element => {
	useEffect(() => {
		void notifyTeamsAppLoaded();
	}, []);

	return (
		<div className="min-h-dvh bg-background text-foreground">
			<main className="mx-auto w-full max-w-3xl p-4">
				<Outlet />
			</main>
		</div>
	);
};

export const Route = createFileRoute("/teams")({
	component: TeamsLayout,
});
